"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var core_1 = require("@material-ui/core");
var theme_1 = require("../../theme");
exports.useStyles = makeStyles_1.default(function (theme) {
    var _a;
    return core_1.createStyles({
        appTop: {
            display: 'flex',
            height: '60px',
            color: (_a = theme_1.contrast()) === null || _a === void 0 ? void 0 : _a.secondary,
        },
    });
});
//# sourceMappingURL=AppTopStyles.js.map